import { Link } from "@inertiajs/react"
import { Shield } from "lucide-react"

import { PlayerStatusBadge } from "@/components/player-status-badge"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table"
import { leagueTeamPlayerPath } from "@/routes"
import type { MatchRosterPlayer } from "@/types"

export function RosterTable({
  roster,
  teamName,
  leagueId,
  teamId,
}: {
  roster: MatchRosterPlayer[]
  teamName: string
  leagueId: string
  teamId: string
}) {
  const activeCount = roster.filter((p) => p.status === "active").length

  return (
    <Card>
      <CardHeader className="pb-3">
        <div className="flex items-center justify-between">
          <CardTitle className="flex items-center gap-2">
            <Shield className="size-4" />
            {teamName}
          </CardTitle>
          <span className="text-muted-foreground text-sm font-semibold">
            {activeCount} active / {roster.length} players
          </span>
        </div>
      </CardHeader>
      <CardContent className="p-0">
        <div className="overflow-hidden">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead className="w-10 text-center">#</TableHead>
                <TableHead>Player</TableHead>
                <TableHead>Position</TableHead>
                <TableHead className="w-20 text-center">Status</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {roster.map((player) => (
                <TableRow
                  key={player.id}
                  className={player.status !== "active" ? "opacity-50" : ""}
                >
                  <TableCell className="text-muted-foreground text-center text-sm">
                    {player.number}
                  </TableCell>
                  <TableCell className="font-semibold">
                    <Link
                      href={leagueTeamPlayerPath(leagueId, teamId, player.id)}
                      className="hover:text-accent transition-colors"
                    >
                      {player.name}
                    </Link>
                  </TableCell>
                  <TableCell className="text-muted-foreground">
                    {player.position}
                  </TableCell>
                  <TableCell className="text-center">
                    <PlayerStatusBadge status={player.status} />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </CardContent>
    </Card>
  )
}
